import { useNavigate } from "react-router";
import routes from "routes/routes";

const useEmployeePayDistributionPage = () => {
  //NOTE:::Constants and external hooks
  const navigate = useNavigate();

  //NOTE:::Methods
  const redirectToBankAccounts = () => {
    navigate(routes.EMPLOYEE_BANK_ACCOUNTS);
  };

  return {
    redirectToBankAccounts,
  };
};

export default useEmployeePayDistributionPage;
